/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import 'react-toastify/dist/ReactToastify.css';
import './style.css';

import Typewriter from '@brands/ChatWindow/ChatComponents/Typewriter';
import VideoPreviewModal from '@brands/ChatWindow/ChatModal/VideoPreviewModal';
import WebCam from '@brands/ChatWindow/WebCam/WebCam';
import { useConversationParticipants } from '@brands/hooks';
import { useQuillMessageBindings } from '@brands/hooks/useQuillMessageBindings';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import { CaseType } from '@brands/services/cases/types/ICase';
import { confirmMedia } from '@brands/services/communication/confirmMedia';
import {
  RegisterMediaPayload,
  registersConversationMedia,
} from '@brands/services/communication/registersConversationMedia';
import { SendMessagePayload } from '@brands/services/communication/sendConversationMessage';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { clearDraft, DraftMedia, saveDraft } from '@brands/store/slices/messageDraftsSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { truncateString } from '@brands/Utils/truncateString';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SendIcon from '@mui/icons-material/Send';
import { Conversation } from '@twilio/conversations';
import { heicTo } from 'heic-to';
import { Editor } from 'primereact/editor';
import React, { useEffect, useRef, useState } from 'react';
import { FaPlay } from 'react-icons/fa';
import { IoCloseCircleOutline } from 'react-icons/io5';
import ReactViewer from 'react-viewer';

import styles from './case-styles.module.scss';
import Format from './Format.svg';

interface IChatFooterProps {
  conversationSid: string | undefined;
  sendMessage: (payload: SendMessagePayload) => void;
  isVCRoom?: boolean;
  isUploadDialogVisible?: boolean;
  choosenFiles: File[];
  setChoosenFiles: React.Dispatch<React.SetStateAction<File[]>>;
  setDisplayProgressBar: React.Dispatch<React.SetStateAction<boolean>>;
  setProgress: React.Dispatch<React.SetStateAction<number>>;
  displayProgressBar: boolean;
  conversationType: string | undefined;
  caseType: CaseType | string;
  twilioConversation: Conversation | null;
  getParticipantName: (identity: string) => string;
}

const CaseChatFooter: React.FC<IChatFooterProps> = ({
  conversationSid,
  sendMessage,
  isVCRoom,
  isUploadDialogVisible,
  choosenFiles,
  setChoosenFiles,
  setDisplayProgressBar,
  setProgress,
  displayProgressBar,
  conversationType,
  caseType,
  twilioConversation,
  getParticipantName,
}) => {
  const { userInfo } = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const [isClearingDraft, setIsClearingDraft] = useState(false);
  const [isRestoringDraft, setIsRestoringDraft] = useState(false);
  const [editorKey, setEditorKey] = useState(0);
  const savedDraft = useAppSelector((state) => state.messageDrafts[conversationSid || '']);
  const [newMessage, setNewMessage] = useState(savedDraft ? savedDraft.text : '');
  const [mediaIds, setMediaIds] = useState<string[]>([]);
  const fileRef = useRef<HTMLInputElement>(null);
  const fileRefMobile = useRef<HTMLInputElement>(null);
  const submitInputRef = useRef<HTMLButtonElement>(null);
  const editorRef = useRef<any>(null);
  const [showFormatting, setShowFormatting] = useState(false);
  const [webCam, setWebCam] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
  const { typingParticipants } = useConversationParticipants(twilioConversation);
  const [videoReviewModal, setVideoReviewModal] = useState({
    isOpen: false,
    videoSrc: '',
  });
  const MAX_CHARS = 7;
  const [processedFiles, setProcessedFiles] = useState<any[]>([]);
  useQuillMessageBindings(editorRef, submitInputRef);
  const toggleFormatting = () => {
    setShowFormatting((prevState) => !prevState);
  };

  const renderHeader = () => {
    return (
      <span className={`ql-formats ${showFormatting ? '' : 'display_none'} `}>
        <button className="ql-bold" aria-label="Bold" />
        <button className="ql-italic" aria-label="Italic" />
        <button className="ql-underline" aria-label="Underline" />
        <button className="ql-list" value="ordered" aria-label="Numbered List" />
        <button className="ql-list" value="bullet" aria-label="Bulleted List" />
      </span>
    );
  };

  const header = renderHeader();

  useEffect(() => {
    const restoreDraft = async () => {
      if (!conversationSid) return;
      setIsRestoringDraft(true);

      setNewMessage(savedDraft?.text || '');

      if (savedDraft?.media?.length) {
        const restoredFiles: File[] = [];
        const restoredProcessed = await Promise.all(
          savedDraft.media.map(async (m) => {
            const blob = await fetch(m.previewURL).then((res) => res.blob());
            const file = new File([blob], m.name, { type: m.type });
            restoredFiles.push(file);
            return {
              name: m.name,
              type: m.type,
              size: m.size,
              previewURL: m.previewURL,
            };
          }),
        );
        setChoosenFiles(restoredFiles);
        setProcessedFiles(restoredProcessed);
      } else {
        setChoosenFiles([]);
        setProcessedFiles([]);
      }

      setTimeout(() => setIsRestoringDraft(false), 200);
    };

    restoreDraft();
  }, [conversationSid, savedDraft]);

  useEffect(() => {
    const processFiles = async () => {
      if (choosenFiles.length > 10) {
        displayErrorDetails("You can't upload more than 10 files at once.");
        const truncatedFiles = choosenFiles.slice(0, 10);
        setChoosenFiles(truncatedFiles);
      }

      const processed = await Promise.all(
        choosenFiles.map(async (mediaFile) => {
          if (mediaFile.type.startsWith('video/')) {
            const thumbnailURL = await generateThumbnailFromFile(mediaFile);
            return {
              ...mediaFile,
              thumbnailURL,
              name: mediaFile.name,
              size: mediaFile.size,
              type: mediaFile.type,
            };
          }
          return mediaFile;
        }),
      );
      setProcessedFiles(processed);
    };

    processFiles();
  }, [choosenFiles]);

  const saveCurrentDraft = async (text: string, files: File[]) => {
    if (isClearingDraft) return;
    if (!conversationSid || !userInfo?.id) return;

    const mediaForDraft: DraftMedia[] = await Promise.all(
      files.map(
        (file) =>
          new Promise<DraftMedia>((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve({
                name: file.name,
                type: file.type,
                size: file.size,
                previewURL: reader.result as string,
              });
            };
            reader.readAsDataURL(file);
          }),
      ),
    );

    dispatch(
      saveDraft({
        conversationId: conversationSid,
        draft: {
          text,
          media: mediaForDraft,
          authorId: userInfo.id,
        },
      }),
    );
  };

  const showUploadDialog = (): void => {
    if (fileRef.current) {
      fileRef.current.click();
    }
    if (fileRefMobile.current) {
      fileRefMobile.current.click();
    }
  };

  const generateThumbnailFromFile = (videoFile: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');

      video.addEventListener('loadedmetadata', () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('Canvas context is not supported'));
          return;
        }

        video.currentTime = 0;
      });

      video.addEventListener('error', (error) => {
        reject(error);
      });

      video.src = URL.createObjectURL(videoFile);

      video.addEventListener('seeked', () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('Canvas context is not supported'));
          return;
        }

        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const thumbnailURL = canvas.toDataURL('image/jpeg');
        resolve(thumbnailURL);
      });

      video.currentTime = 0;
    });
  };

  const uploadFile = async (file: File, onProgress: (progress: number) => void): Promise<string | undefined> => {
    try {
      const payload: RegisterMediaPayload = {
        files: [
          {
            filename: file.name,
            mimetype: file.type,
          },
        ],
      };

      const res = await registersConversationMedia(conversationSid!, payload);
      const mediaId = res.files[0].upload_id;

      return await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', res.files[0].upload_url, true);
        xhr.setRequestHeader('Content-Type', file.type);

        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            const progress = Math.floor((event.loaded / 1.0 / event.total) * 100);
            onProgress(progress);
          }
        });

        xhr.onreadystatechange = function () {
          if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
              confirmMedia(conversationSid!, mediaId)
                .then(() => {
                  resolve(mediaId);
                })
                .catch((error) => {
                  reject(error);
                });
            } else {
              reject(new Error('Something went wrong'));
            }
          }
        };

        xhr.send(file);
      });
    } catch (error: unknown) {
      displayErrorDetails(error);
      return undefined;
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const { files } = event.currentTarget;
    if (!files) {
      return;
    }

    const maxFiles = 10 - choosenFiles.length;

    if (files.length > maxFiles) {
      displayErrorDetails("You can't upload more than 10 files at once.");
      return;
    }

    const fileArray = Array.from(files).slice(0, maxFiles);

    const convertedFiles = await Promise.all(
      fileArray.map(async (file) => {
        const fileName = file.name;

        // Check if the file already exists in the chosen files
        if (choosenFiles.some((existingFile) => existingFile.name === fileName)) {
          displayErrorDetails(`File "${fileName}" already exists.`);
          return null;
        }

        // Convert HEIC files to JPEG
        if (file.type === 'image/heic') {
          try {
            const jpegBlob = await heicTo({
              blob: file,
              type: 'image/jpeg',
              quality: 0.85,
            });

            return new File([jpegBlob], fileName.replace(/\.heic$/i, '.jpeg'), {
              type: 'image/jpeg',
            });
          } catch (error) {
            displayErrorDetails(`Error converting HEIC file "${fileName}" to JPEG: ${error}`);
            return null;
          }
        }

        return file;
      }),
    );

    const filteredFiles = convertedFiles.filter((file) => file !== null) as File[];
    setChoosenFiles([...choosenFiles, ...filteredFiles]);
    saveCurrentDraft(newMessage, [...choosenFiles, ...filteredFiles]);

    if (fileRef.current) {
      fileRef.current.value = '';
    }
  };

  const clearDraftForConversation = () => {
    if (conversationSid) {
      dispatch(
        saveDraft({
          conversationId: conversationSid,
          draft: {
            text: '',
            media: [],
            authorId: userInfo.id,
          },
        }),
      );
      dispatch(clearDraft(conversationSid));
      setIsClearingDraft(false);
    }
  };

  const onFormSubmit = async (e: any): Promise<void> => {
    e.preventDefault();
    e.stopPropagation();
    setIsClearingDraft(true);
    if (newMessage && choosenFiles.length === 0) {
      sendMessage({ body: newMessage, media_ids: mediaIds });
      if (editorRef.current?.getQuill) {
        editorRef.current.getQuill().setContents([{ insert: '\n' }]);
      }
      setNewMessage('');
      setMediaIds([]);
    } else if (choosenFiles.length) {
      setDisplayProgressBar(true);

      try {
        let totalUploaded = 0; // Keep track of total uploaded files
        const uploadedMediaIds: string[] = [];

        // Loop through each file and upload them
        for (const choosenFile of choosenFiles) {
          const mediaId = await uploadFile(choosenFile, (progress) => {
            // Calculate the overall progress based on the number of uploaded files
            const overallProgress = Math.floor((totalUploaded * 100 + progress) / choosenFiles.length);
            setProgress(overallProgress);
          }).catch((error) => {
            displayErrorDetails(`Error uploading file: ${error}`);
          });

          if (mediaId) {
            uploadedMediaIds.push(mediaId);
            totalUploaded++;
          }
        }

        // Set the progress to 100% after all files are uploaded
        setProgress(100);

        // Send message with uploaded media IDs
        sendMessage({ body: newMessage || '', media_ids: uploadedMediaIds });

        if (editorRef.current?.getQuill) {
          editorRef.current.getQuill().setContents([{ insert: '\n' }]);
        }

        setNewMessage('');
        setChoosenFiles([]);
        setProcessedFiles([]);
        setMediaIds([]);
        clearDraftForConversation();
      } catch (error: unknown) {
        displayErrorDetails(error);
      } finally {
        setProgress(0);
        setDisplayProgressBar(false);
      }
    }
  };

  const openImageModal = (index: number, media: any) => {
    const isImage = /\.(jpg|jpeg|png|gif|jfif|pjpeg|pjp)$/i.test(media.name);
    const isPdf = /\.pdf$/i.test(media.name);
    const isVideo = /\.(mp4|mov)$/i.test(media.name);

    if (isImage) {
      const imageMedias = choosenFiles.filter((image) => /\.(jpg|jpeg|png|gif|jfif|pjpeg|pjp)$/i.test(image.name));
      const imageIndex = imageMedias.findIndex((processedFiles) => processedFiles.name === media.name);
      setSelectedImageIndex(imageIndex);
      setShowModal(true);
    } else if (isPdf) {
      // Handle opening PDF in a new tab
      window.open(URL.createObjectURL(choosenFiles[index]), '_blank');
    } else if (isVideo) {
      setVideoReviewModal({ isOpen: true, videoSrc: URL.createObjectURL(choosenFiles[index]) });
    }
  };

  const deleteMedia = (mediaName: string): void => {
    if (!isClearingDraft) {
      const newChosenList = choosenFiles.filter((item) => item.name !== mediaName);
      const newProcessedList = processedFiles.filter((item) => item.name !== mediaName);

      setChoosenFiles(newChosenList);
      setProcessedFiles(newProcessedList);

      // Update Redux draft after deletion
      if (conversationSid && userInfo?.id) {
        const updatedMediaDraft = newProcessedList.map((file) => ({
          name: file.name,
          type: file.type,
          size: file.size,
          previewURL: file.previewURL,
          thumbnailURL: file.thumbnailURL,
        }));
        dispatch(
          saveDraft({
            conversationId: conversationSid,
            draft: {
              text: newMessage,
              media: updatedMediaDraft,
              authorId: userInfo.id,
            },
          }),
        );
      }
    }
  };

  useEffect(() => {
    if (isUploadDialogVisible) {
      showUploadDialog();
    }
  }, [isUploadDialogVisible]);

  const onTextareaKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      if (submitInputRef.current) {
        submitInputRef.current.click();
      }
    }
  };

  useEffect(() => {
    setEditorKey((prev) => prev + 1);
  }, [conversationSid]);

  return (
    <>
      {(userInfo.role.name === UserRoleName.CareAdvisor || userInfo.role.name === UserRoleName.Provider || userInfo.role.name === UserRoleName.Collector) &&
        conversationType &&
        (conversationType === `${UserRoleName.Patient}_${UserRoleName.CareAdvisor}` ||
          conversationType === `${UserRoleName.Patient}_${UserRoleName.Provider}`) && (
          <div>
            <div className={styles.warningMessage}>
              <span>Warning</span>
              <span>
                {caseType === CaseType.phone_call_scheduled
                  ? 'Warning Messages sent to this conversation are viewable by the patient. This patient may not have internet access. Please don’t rely on this communication channel'
                  : 'Messages sent to this conversation are viewable by the patient'}
              </span>
            </div>
          </div>
        )}
      <div className={styles.typingIndicatordiv}>
        {typingParticipants.length > 0 && (
          <p className={styles.typingIndicatorP}>
            <Typewriter />
            <span className={styles.typingIndicatorName}>{typingParticipants.map(getParticipantName).join(', ')} </span>
            <span className={styles.typingIndicatorText}>
              {typingParticipants.length === 1 ? 'is typing' : 'are typing'}
            </span>
          </p>
        )}
      </div>
      <form
        style={{ width: '100%' }}
        className={`fs-unmask new-design-form ${styles.inputForm}`}
        onSubmit={onFormSubmit}
      >
        <div className={`fs-unmask ${styles.inputIcons} ${showFormatting && styles.inputIconsExpand}`}>
          <div className={styles.chatInputDiv}>
            <Editor
              key={editorKey}
              ref={editorRef}
              className={`fs.exclude ${styles.chatInput}`}
              value={newMessage}
              onTextChange={(e) => {
                const text = e.htmlValue || '';
                setNewMessage(text);

                if (!isRestoringDraft && !isClearingDraft) {
                  saveCurrentDraft(text, choosenFiles);
                } else if (isClearingDraft) {
                  setIsClearingDraft(false);
                }

                twilioConversation?.typing();
              }}
              style={{ maxHeight: '320px' }}
              headerTemplate={header}
              placeholder="Write a message"
              onKeyDown={onTextareaKeyDown}
            />

            <div className={styles.uploadMediaDiv} style={{ display: processedFiles.length === 0 ? 'none' : 'block' }}>
              <ul>
                {processedFiles.map((mediaFile, index) => (
                  <li key={`${mediaFile.name}-${index}`} className={styles.thumbnailDiv}>
                    <span className={styles.participantSpan} onClick={() => openImageModal(index, mediaFile)}>
                      {mediaFile.type.startsWith('image/') ? (
                        <>
                          <img
                            src={
                              mediaFile instanceof File || mediaFile instanceof Blob
                                ? URL.createObjectURL(mediaFile)
                                : mediaFile.previewURL
                            }
                            alt={mediaFile.name}
                            className={`fs.exclude ${styles.thumbnail}`}
                          />
                          <div className={styles.grayOverlay} />
                        </>
                      ) : mediaFile.type.startsWith('video/') ? (
                        <div className={styles.videoThumbnail}>
                          <img
                            src={mediaFile.thumbnailURL ?? mediaFile.previewURL}
                            alt={mediaFile.name}
                            className={`fs.exclude ${styles.thumbnail}`}
                          />
                          <div className={styles.videoOverlay}>
                            <FaPlay />
                          </div>
                          <div className={styles.grayOverlay} />
                        </div>
                      ) : (
                        <div className={`fs.exclude ${styles.pdfThumbnail}`}>
                          <InsertDriveFileIcon color="primary" />
                          <span>
                            {truncateString(
                              decodeURIComponent(
                                mediaFile.name
                                  .split('?')[0]
                                  .split('/')
                                  .pop()
                                  ?.split('-')
                                  ?.pop()
                                  ?.replace(/%[0-9A-Fa-f]{2}/g, (match: string) =>
                                    String.fromCharCode(parseInt(match.substr(1), 16)),
                                  ) ?? '',
                              ),
                              MAX_CHARS,
                            )}
                          </span>
                          <div className={styles.grayOverlay} />
                        </div>
                      )}
                    </span>
                    <IoCloseCircleOutline className={styles.deleteIcon} onClick={() => deleteMedia(mediaFile.name)} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className={styles.mediaIcons} style={{ display: isVCRoom ? 'none' : '' }}>
            <img src={Format} className={styles.formatIcon} onClick={toggleFormatting} alt="Format Icon" />
            <label htmlFor="formId" className={styles.chatUploadImg} aria-label="Upload Image">
              <input
                ref={fileRef}
                onChange={handleFileChange}
                multiple
                type="file"
                hidden
                accept=".png, .mov, .jpg , .jpeg , .jfif , .pjpeg , .pjp, .pdf, .mp4, .heic, .doc, .docx, .ppt, .pptx,"
              />
              <button type="button" onClick={showUploadDialog} aria-label="Upload Image">
                <AttachFileIcon className={styles.imageIcon} />
              </button>
            </label>
            <CameraAltOutlinedIcon
              className={styles.cameraIcon}
              style={{ display: isVCRoom ? 'none' : '' }}
              onClick={() => setWebCam(true)}
            />
          </div>
        </div>
        <button
          ref={submitInputRef}
          type="submit"
          style={{ width: '46px', height: 'fit-content', alignSelf: 'center' }}
          aria-label="Send Message"
          disabled={displayProgressBar}
          className={`fs-unmask ${styles.inputFormSend}`}
        >
          <div>
            <SendIcon className={styles.sendIcon}>
              <input type="submit" name="submit" />
            </SendIcon>
          </div>
        </button>
      </form>
      {webCam && (
        <WebCam
          setOpenModal={setWebCam}
          setChoosenFiles={setChoosenFiles}
          choosenFiles={choosenFiles}
          saveCurrentDraft={saveCurrentDraft}
          newMessage={newMessage}
        />
      )}
      <ReactViewer
        visible={showModal}
        onClose={() => setShowModal(false)}
        images={choosenFiles
          .filter((image) => /\.(jpg|jpeg|png|gif|jfif|pjpeg|pjp)$/i.test(image.name))
          .map((file) => ({ src: URL.createObjectURL(file) }))}
        activeIndex={selectedImageIndex}
      />
      {videoReviewModal.isOpen && (
        <VideoPreviewModal setOpenModal={setVideoReviewModal} videoReviewModal={videoReviewModal} />
      )}
    </>
  );
};
CaseChatFooter.defaultProps = {
  isVCRoom: false,
  isUploadDialogVisible: false,
};
export default CaseChatFooter;
